const effects = {
    fadeIn: 'fadeOut',
    zoomIn: 'zoomOut',
    slideVertical: 'slideVerticalOut',
    slideHorizontal: 'slideHorizontalOut'
};
export default effects;